import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-user-star-line',
      title: t('about.feature1Title'),
      description: t('about.feature1Desc')
    },
    {
      icon: 'ri-microscope-line',
      title: t('about.feature2Title'),
      description: t('about.feature2Desc')
    },
    {
      icon: 'ri-award-line',
      title: t('about.feature3Title'),
      description: t('about.feature3Desc')
    },
    {
      icon: 'ri-heart-pulse-line',
      title: t('about.feature4Title'),
      description: t('about.feature4Desc')
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image with Stats Card */}
          <div className="relative">
            <div className="relative h-[500px] rounded-2xl overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/1587c2986f99cf9c96f6c0614881ca2d.jpeg"
                alt="Zimbet32 Clinic Interior"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
            
            {/* Stats Card Overlay */}
            <div className="absolute bottom-8 left-8 right-8 bg-white rounded-xl shadow-2xl p-6">
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-4xl font-bold text-teal-600 mb-1">2004</div>
                  <div className="text-sm text-gray-600">{t('about.foundedYear')}</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-teal-600 mb-1">20+</div>
                  <div className="text-sm text-gray-600">{t('about.yearsExperience')}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              {t('about.title')}
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              {t('about.description')}
            </p>

            {/* Features List */}
            <div className="space-y-5 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <button 
              onClick={() => {
                const contactSection = document.getElementById('contact');
                contactSection?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('about.ctaButton')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;